import { render, staticRenderFns } from "./formScore.vue?vue&type=template&id=715440e5&scoped=true"
import script from "./formScore.vue?vue&type=script&lang=js"
export * from "./formScore.vue?vue&type=script&lang=js"
import style0 from "./formScore.vue?vue&type=style&index=0&id=715440e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715440e5",
  null
  
)

export default component.exports